import { Box } from '@mui/material';
import { RenderForm } from '@uplift/pages';
import { UpliftThemeProvider } from '@uplift/ui-v2';

export const FormPage: React.VFC = () => (
  <UpliftThemeProvider>
    <Box position="relative">
      <RenderForm />
    </Box>
  </UpliftThemeProvider>
);
